import { create } from 'zustand';

type userState = {
  userId: string | undefined
  setUserId: (value: string) => void
};

const useUserState = create<userState>(set => ({
  userId: '4', // Defaulting as Sarah Alali if not signed in. Only for the demo
  setUserId: userId => set({ userId: userId }),
}));

export default useUserState;
